import React from 'react';
import { setCurrentView } from 'core/utils';
import { LabelingModeViewStore } from 'modules/order/stores';
import { LabelingModeTemplate } from 'themes/modules/order/pages';

@setCurrentView(rootStore => new LabelingModeViewStore(rootStore), 'labelingModeViewStore')
class LabelingMode extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <LabelingModeTemplate {...this.props} />;
	}
}

export default LabelingMode;



// WEBPACK FOOTER //
// ./src/modules/order/pages/LabelingMode.jsx